<template>
    <v-sheet
        class="w-100 pa-4 my-4"
        border
        rounded
        elevation="1"
        color="background"
    >
        <div class="d-flex align-center">
            <v-icon
                color="primary"
                :class="
                    item.estatus == 3
                        ? 'text-tertiary'
                        : item.estatus == 2
                        ? 'text-secondary'
                        : 'text-primary'
                "
                :icon="
                    item.estatus == 3
                        ? 'mdi-alert-circle'
                        : item.estatus == 2
                        ? 'mdi-checke-circle'
                        : 'mdi-information-outline'
                "
                size="small"
                class="me-2"
            ></v-icon>
            <p
                class="text-body-2 text-primary font-weight-bold text-uppercase"
                :class="
                    item.estatus == 3
                        ? 'text-tertiary'
                        : item.estatus == 2
                        ? 'text-secondary'
                        : 'text-primary'
                "
            >
                {{ t("afiliadas.estatus.etiqueta") }}:
                {{ t("afiliadas.estatus." + item.estatus + ".titulo") }}
            </p>
        </div>
        <div
            class="text-body-2 text-textDark text-justify mt-2 pl-6"
            v-if="item.estatus == 3"
        >
            {{ item.revision_comentarios }}
        </div>
        <div class="text-body-2 text-textDark text-justify mt-2 pl-6" v-else>
            {{ t("afiliadas.estatus." + item.estatus + ".texto") }}
        </div>
    </v-sheet>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const props = defineProps({
    item: Object,
});

const { t } = useI18n();
</script>
